<template>
  <div v-if="show">
    <!-- 蒙版 -->
    <div class="mask" @touchmove.prevent></div>
    <div class="pop">
      <div class="voice">
        <el-container>
          <el-aside>
            <div class="conver-title">
              <div class="title-name">{{ title }}</div>
              <div class="add" @click="addNew('add')">
                <img src="@/icon/rcord_add.png" alt="添加" />
              </div>
            </div>
            <div class="search">
              <el-input placeholder="用户名称" v-model="userName" class="search-name">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="serachLine">
              <ul>
                <li
                  v-for="(item, index) in searchData"
                  :key="index"
                  @click="currenPerson(item)"
                  :class="[currenData.id === item.id ? 'curren-hight' : '', index === hoverIndex ? 'hoverBg' : '']"
                  @mouseenter="hoverIndex = index"
                >
                  <div class="head-port" v-if="title === '语音消息'">
                    <!-- {{ item.image }} -->
                    <i class="is-read" v-if="item.signRead === 0"></i>
                  </div>
                  <div class="info-port">
                    <p
                      :class="[
                        title === '语音消息' ? 'person-name' : 'broad-name',
                        theme === 'default' ? 'name-light' : 'name-dark',
                      ]"
                    >
                      <img
                        v-if="title === '广播' && currenData.id === item.id && theme !== 'default'"
                        src="@/icon/voice/ic_group.png"
                        class="group_icon"
                      />
                      <img
                        v-if="title === '广播' && currenData.id !== item.id && theme !== 'default'"
                        src="@/icon/voice/person_off.png"
                        class="group_icon"
                      />
                      <img
                        v-if="title === '广播' && currenData.id === item.id && theme === 'default'"
                        src="@/icon/voice/icon_light_on.png"
                        class="group_icon"
                      />
                      <img
                        v-if="title === '广播' && currenData.id !== item.id && theme === 'default'"
                        src="@/icon/voice/icon_light_off.png"
                        class="group_icon"
                        :title="item.groupName"
                      />
                      {{ item.sessionName | ellipsisEight }}
                    </p>
                    <p>{{ item.ouName }}</p>
                  </div>
                  <div class="icon-right">
                    <div class="last-time">{{ item.lastVoiceTime }}</div>
                    <img src="@/icon/ic_delete.png" class="addicon" alt="删除" @click="delectItem(item)" />
                  </div>
                </li>
                <li v-if="searchData.length === 0" class="no-data">
                  {{ title === '广播' ? '暂无聊天群组' : '暂无聊天人员' }}
                </li>
              </ul>
            </div>
          </el-aside>
          <el-main>
            <div class="log-title">
              <div
                class="groupArr"
                :class="theme === 'default' ? 'group-light' : 'group-dark'"
                v-if="title === '广播' && searchData.length !== 0"
                alt=""
              ></div>
              <span>{{ currenData.sessionName }}</span>
              <img
                :src="require(theme === 'default' ? '@/icon/voice/edit_borst.png' : '@/icon/voice/edit_deep.png')"
                class="edit_borst"
                v-if="title === '广播' && searchData.length !== 0"
                @click="changeArr"
                alt="编辑"
              />
              <i class="sys-close-btn" @click="infinityVoice"></i>
              <!-- <img @click="infinityVoice" class="close" src="@/icon/ic_cancle.png" alt="关闭" /> -->
            </div>
            <div id="log">
              <div class="chat" ref="chatContent">
                <!-- 聊天记录 -->
                <div class="waveform" ref="waveform" v-for="(item, index) in lists" :key="index">
                  <div
                    v-if="item.type !== 2"
                    :class="
                      item.userId === currenData.userId && recordType === 0 ? 'message-row-left' : 'message-row-right'
                    "
                  >
                    <audio controls autoplay id="audio" ref="audioUrlRefText" :src="fileUrl"></audio>
                    <div class="portrait">
                      <!-- {{ userid !== item.userId ? item.image : '我' }} -->
                    </div>
                    <div class="info-chat" v-if="item.address">
                      <div
                        :class="
                          item.userId === currenData.userId && recordType === 0 ? 'nick-name-left' : 'nick-name-right'
                        "
                      >
                        <span class="nick-name">{{ item.userName }}</span>
                        <span class="nick-time">{{ item.time }}</span>
                      </div>
                      <Trigger
                        @playAudioHandler="playAudioHandler"
                        :style="widthPercent(item.length)"
                        :recordType="recordType"
                        :index="index"
                        :isPlaying="isPlaying"
                        :playKey="playKey"
                        :item="item"
                        :currenData="currenData"
                        :userid="userid"
                      >
                      </Trigger>
                    </div>
                    <div class="text-chat" v-if="item.message">
                      <div class="nick-time">{{ item.time }}</div>
                      <div class="message-text">
                        <div>{{ item.message }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="message-alert" v-if="item.type === 2">
                    {{ item.message }}
                  </div>
                </div>
              </div>
            </div>
            <div class="talk">
              <!-- 语音 -->
              <div class="loader"><Ripple v-if="recording"></Ripple></div>
              <div
                class="play-icon"
                :class="theme === 'default' ? 'play-light' : 'play-dark'"
                v-if="news_img"
                @click="handleBtnClick"
                @mouseenter="changeImageSrc('hover')"
                @mouseleave="changeImageSrc('')"
              ></div>
              <div
                class="play-icon"
                v-if="endPlay"
                :class="theme === 'default' ? 'endPlay-light' : 'endPlay-dark'"
                @click="cancel_mp3"
                @mouseenter="changeIcon('in')"
                @mouseleave="changeIcon('out')"
              ></div>
              <div class="send-cancel" v-if="sendCancel">
                <img
                  @click="send_voice"
                  class="send-btn"
                  v-if="theme === 'default'"
                  src="@/icon/voice/record_send.png"
                  alt="发送"
                />
                <img
                  @click="cancel"
                  class="cancel-btn"
                  v-if="theme === 'default'"
                  src="@/icon/voice/record_cancel.png"
                  alt="取消"
                />
                <!-- 深色 -->
                <img
                  @click="send_voice"
                  class="send-btn"
                  v-if="theme === 'dark'"
                  src="@/icon/voice/ic_record_send.png"
                  alt="发送"
                />
                <img
                  @click="cancel"
                  class="cancel-btn"
                  v-if="theme === 'dark'"
                  src="@/icon/voice/ic_record_cancel.png"
                  alt="取消"
                />
              </div>
              <div class="stop-talk" v-if="stopTip">语音将在 {{ stopMinutes }} 秒后自动停止录音</div>
            </div>
          </el-main>
        </el-container>
      </div>
      <el-dialog title="" :visible.sync="setAlertVisible" width="100%" top="0" :close-on-click-modal="false">
        <div id="setRecord">
          <div class="addRecord">
            <img @click="setAlertVisible = false" class="back-record" src="@/icon/back.png" alt="" />
            <span class="addRecord-title">{{
              title === '语音消息' ? '添加语音消息' : editType === '1' ? '编辑广播群组' : '添加广播群组'
            }}</span>
            <i class="sys-close-btn record-close" @click="setAlertVisible = false"></i>
          </div>
          <div class="group" v-if="title === '广播'">
            <div class="group-name">广播群组名称</div>
            <el-input placeholder="请填写" v-model="groupName" maxlength="16"></el-input>
            <div class="select-title">选择成员</div>
            <el-input placeholder="搜索" v-model="addUsername" class="serch-add">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div class="group" v-else>
            <el-input placeholder="搜索" v-model="addUsername" class="serch-add">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <div :class="title === '广播' ? 'broad' : 'conversat'">
            <div v-if="ouList.length > 0">
              <elTree2
                ref="userTree"
                :data="ouList"
                :check-on-click-node="false"
                :default-checked-keys="userCheckedList"
                show-checkbox
                node-key="id"
                :filter-node-method="filterNode"
                default-expand-all
                :check-strictly="true"
                :props="ouTreeProps"
                @check-change="handleClick"
              >
              </elTree2>
            </div>
            <div v-else class="setTree">
              请往 ‘个人信息-个人设置’ 设置【接受语音范围】
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-if="editType === '0'" @click="updateUser()">确定</el-button>
          <el-button type="primary" v-if="editType === '1'" @click="editUser()">确定</el-button>
          <el-button @click="cancelUpdate">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Recorderx, { ENCODE_TYPE } from 'recorderx'
const rc = new Recorderx()
import {
  uploadFile,
  getSelectList,
  getSelecttreeList,
  saveCall,
  saveBroadcast,
  delSession,
  getVoiceList,
  getUserTree,
  getMember,
  updateBroadcast,
  refreshVoice,
  updateSessionRead,
} from '@/api/vChat'
import { errorCollection } from '@/api/dmp/dmpCollection'
import store from '../../store/index'
import Ripple from '@/components/voice/ripple'
import elTree2 from '@/components/vTree/src/tree'
import { getSession } from '@/api/common'
import Trigger from '@/components/voice/trigger'
export default {
  data() {
    return {
      news_img: true,
      chatList: [], // 聊天信息展示数据
      show: false,
      title: '',
      userName: '',
      searchData: [],
      setAlertVisible: false,
      ouTreeProps: {
        label: 'name',
        children: 'children',
      },
      ouList: [],
      addUsername: '',
      recording: false,
      endPlay: false,
      sendCancel: false,
      currenData: [],
      groupName: '',
      userCheckedList: [],
      fileUrl: '',
      fileTime: '',
      isPlaying: false,
      PlayId: '',
      playKey: null,
      editType: '',
      audioTime: 0,
      minutes: 0,
      clearTime: '',
      pageSize: 7,
      pageNum: 1,
      lists: [],
      totalPages: '',
      userid: getSession('userId'),
      wsData: [],
      hoverIndex: -1,
      theme: localStorage.getItem('theme'),
      lastTime: 0,
      IsScroll: true,
      lastScrollHeight: 0,
      clearaudioTime: '',
      stopMinutes: 9,
      stopTip: false,
    }
  },
  components: { Ripple, elTree2, Trigger },
  methods: {
    infinityVoice() {
      this.show = false
      store.commit('voiceShow', false)
      // console.log(this.show,store)
    },
    updateIsRead(val) {
      // 更新未读
      let params = { sessionId: this.currenData.id }
      updateSessionRead(params).then(res => {
        if (res.state === 0) {
          var newSearchData = []
          for (let item of this.searchData) {
            if (item.id === val.id) {
              item.signRead = 1
            }
            newSearchData.push(item)
          }
          this.searchData = newSearchData
        }
      })
    },
    // 会话单选
    handleClick(data, checked, node) {
      if (this.recordType === 0) {
        if (checked) {
          let arr = [data.id]
          this.$refs.userTree.setCheckedKeys(arr)
        }
      }
    },
    // 点击播放 暂停录音
    playAudioHandler(item, key) {
      var audio = document.getElementById('audio')
      if (this.playKey !== key) {
        this.isPlaying = true
        if (item.expiryTime && new Date().getTime() > new Date(item.expiryTime).getTime()) {
          this._refreshVoice(item)
        } else {
          document.getElementById('audio').src = item.address
          this.timer(item)
        }
      } else {
        this.isPlaying = !this.isPlaying
        if (this.isPlaying === true) {
          document.getElementById('audio').src = item.address
          this.timer(item)
        } else {
          audio.pause()
          clearTimeout(this.clearaudioTime)
        }
      }
      this.playKey = key
      this.PlayId = item.userId
    },
    // 刷新当前点击过期语音
    _refreshVoice(item) {
      let param = { msgId: item.id }
      refreshVoice(param).then(res => {
        if (res.state === 0 && res.data) {
          document.getElementById('audio').src = res.data.address
          this.timer(res.data)
        }
      })
    },
    // 倒计时语音动画
    timer(item) {
      if (item['length']) {
        this.audioTime = Number(item['length'])
      } else {
        this.audioTime = item
      }
      if (this.audioTime > 0) {
        this.audioTime--
        this.clearaudioTime = setTimeout(() => {
          this.timer(this.audioTime)
        }, 1000)
      } else {
        clearTimeout(this.clearaudioTime)
        this.time = 0
        this.isPlaying = false
      }
    },
    toScrollBottom() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.lastScrollHeight = this.$refs.chatContent.scrollHeight
          this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight
          this.$refs.chatContent.style.visibility = 'visible'
        })
      }, 300)
    },
    handleScroll() {
      //监听滚动条加载更多历史录音
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.$refs.chatContent) {
            let scrollTop = this.$refs.chatContent.scrollTop
            if (scrollTop === 0) {
              if (this.IsScroll === true) {
                if (this.pageNum < this.totalPages) {
                  this.pageNum = this.pageNum + 1
                  this._getVoiceList('nowadd')
                  this.IsScroll = false
                }
              }
            }
          }
        })
      }, 1000)
    },
    _getVoiceList(val) {
      // 获取录音列表
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sessionId: this.currenData.id,
      }
      getVoiceList(param).then(res => {
        if (res.state === 0) {
          if (res.data.list.length > 0) {
            this.totalPages = res.data.pages
            if (this.recordType === 0) {
              this.converList(res.data.list, val)
            } else if (this.recordType === 1) {
              this.broadList(res.data.list, val)
            }
          } else {
            this.lists = []
          }
        }
        this.$refs.chatContent.style.visibility = this.pageNum === 1 ? 'hidden' : ''
      })
    },
    converList(data, val) {
      // 通话录音列表
      this.chatList = []
      for (let item of data) {
        if (item.type === 0 || item.type === 2) {
          item.image = item.userName.split('')[0]
          let data = item.createdTime.split(' ')[0]
          let newdata = data.split('-')
          item.time = newdata[1] + '月' + newdata[2] + '日' + item.createdTime.split(' ')[1]
          this.chatList.push(item)
        }
      }
      this.lists = this.chatList.concat(this.lists)
      val !== 'nowadd' ? this.toScrollBottom() : ''
      this.IsScroll = true
      this.handleList()
    },
    broadList(data, val) {
      // 广播录音列表
      this.chatList = []
      for (let item of data) {
        if (item.type === 1) {
          item.image = item.userName.split('')[0]
          let data = item.createdTime.split(' ')[0]
          let newdata = data.split('-')
          item.time = newdata[1] + '月' + newdata[2] + '日' + item.createdTime.split(' ')[1]
          this.chatList.push(item)
        }
      }
      this.lists = this.chatList.concat(this.lists)
      val !== 'nowadd' ? this.toScrollBottom() : ''
      this.IsScroll = true
      this.handleList()
    },
    handleList() {
      // 历史记录位置不变
      this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight - this.lastScrollHeight + 10
      this.lastScrollHeight = this.$refs.chatContent.scrollHeight
    },
    delectItem(node) {
      // 删除会话
      console.log(node, 'node')
      this.$confirm('确认删除该会话? 删除后数据将不能恢复!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let param = {
          id: node.id,
          tenantId: node.tenantId,
          sessionName: node.sessionName,
          ouId: node.ouId,
          type: node.type,
          userId: node.userId,
          userName: node.userName,
        }
        delSession(param).then(res => {
          if (res.state === 0) {
            this.IsScroll = false
            this._getSelectList('', '')
            this.currenData = []
            this.lists = []
          }
        })
      })
    },
    _getMember() {
      let param = {
        sessionId: this.currenData.id,
        type: this.recordType,
      }
      getMember(param).then(res => {
        if (res.state === 0) {
          console.log(res)
        }
      })
    },
    addNew(type) {
      // 点击添加人员、群
      if (type === 'add') {
        this.userCheckedList = []
        this.groupName = ''
        this.editType = '0'
      } else {
        this._getMember()
        this.getUserTree()
        this.editType = '1'
      }
      this.addUsername = ''
      let params = {
        type: this.recordType,
        allDevice: 1,
      }
      getSelecttreeList(params).then(res => {
        if (res.state === 0) {
          this.ouList = res.data
          this.setAlertVisible = true
          window.removeEventListener('scroll', this.handleScroll, true)
        }
      })
    },
    getUserTree() {
      // 获取群组人员列表树
      this.userCheckedList = []
      let params = {
        sessionId: this.currenData.id,
      }
      getUserTree(params).then(res => {
        if (res.state === 0) {
          setTimeout(() => {
            this.$nextTick(() => {
              for (let item of res.data) {
                this.userCheckedList.push(item.toString())
              }
              console.log(this.userCheckedList)
              this.$refs.userTree.setCheckedKeys(this.userCheckedList)
            })
          }, 300)
        }
      })
    },
    changeArr() {
      // 编辑群人员
      this.groupName = this.currenData.sessionName
      this.addNew('edit')
    },
    _getSelectList(val, id, data) {
      // 查询已有人员/群组列表
      let params = {
        sessionName: val,
        type: this.recordType,
      }
      getSelectList(params).then(res => {
        if (res.state === 0) {
          this.searchData = res.data
          if (this.searchData.length > 0) {
            if (id !== '') {
              for (let item of this.searchData) {
                if (id === item.id || id === item.sessionName) {
                  this.currenData = item
                  this.updateIsRead(this.currenData)
                }
              }
            } else {
              if (data === undefined || this.searchData.length === 1) {
                this.currenData = this.searchData[0]
                if (this.show === true) {
                  this.updateIsRead(this.currenData)
                }
              } else {
                if (data.alertType !== undefined) {
                  for (let item of this.searchData) {
                    if (data.userId === item.userId) {
                      this.currenData = item
                    }
                  }
                  this.updateIsRead(this.currenData)
                } else {
                  this.currenData = this.currenData
                }
              }
            }
            this.getVoiceTime()
            this.refreshVoiceList(data)
          } else {
            this.lists = []
            this.currenData = []
            this.IsScroll = false
          }
        }
      })
    },
    getVoiceTime() {
      for (let item of this.searchData) {
        if (item.lastVoiceTime !== null) {
          let timeData = item.lastVoiceTime.split(' ')[1]
          let newdata = timeData.split(':')
          item.lastVoiceTime = newdata[0] + ':' + newdata[1]
        }
      }
    },
    refreshVoiceList(data) {
      // 是否刷新当前聊天记录
      if (this.wsData.sessionId) {
        if (this.wsData.sessionId === this.currenData.id) {
          this.lists = []
          this.pageNum = 1
          this._getVoiceList(data)
          if (this.show === true && this.currenData.length !== 0) {
            this.updateIsRead(this.currenData)
          }
        }
      } else {
        this.lists = []
        this.pageNum = 1
        this._getVoiceList(data)
      }
    },
    currenPerson(item) {
      // 当前聊天
      this.lists = []
      this.wsData = []
      this.currenData = item
      this.toScrollBottom()
      item.signRead === 0 ? this.updateIsRead(this.currenData) : ''
      this.endPlay = false
      this.sendCancel = false
      this.news_img = true
      this.recording = false
      this.isPlaying = false
      clearInterval(this.clearTime)
      rc.clear()
      this._getSelectList('', item.id)
    },
    changeImageSrc(type) {
      if (this.recording === true && type === 'hover') {
        this.endPlay = true
        this.recording = false
      }
    },
    changeIcon(type) {
      // 结束icon变化
      if (type === 'in') {
        this.recording = false
        this.endPlay = true
      } else if (type === 'out' && this.news_img !== false) {
        this.recording = true
        this.endPlay = false
      } else if (type === 'out' && this.news_img === false) {
        this.recording = false
        this.endPlay = false
      }
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    editUser() {
      // 编辑群名/人员
      let NodesArr = this.$refs.userTree.getCheckedNodes()
      let idArr = []
      for (let item of NodesArr) {
        // 单个成员判断
        if (item.ouId) {
          idArr.push(item.id)
        }
      }
      if (this.groupName === '') {
        this.$message({ type: 'error', message: '请输入广播群组名称!' })
        errorCollection('语音通讯', '编辑广播群组', { status: 200, data: { state: -1, msg: '请输入广播群组名称!' } })
      } else if (idArr.length === 0) {
        this.$message({ type: 'error', message: '请选择至少一位群员!' })
        errorCollection('语音通讯', '编辑广播群组', { status: 200, data: { state: -1, msg: '请选择至少一位群员!' } })
      } else {
        let params = {
          sessionId: this.currenData.id,
          sessionName: this.groupName,
          userIds: idArr,
        }
        updateBroadcast(params).then(res => {
          if (res.state === 0) {
            this._getSelectList('', this.groupName)
            this.setAlertVisible = false
            window.addEventListener('scroll', this.handleScroll, true)
            this.groupName = ''
          }
        })
      }
    },
    updateUser(userId) {
      // 确定新增通话或广播
      console.log(userId, this.title)
      if (this.title === '语音消息') {
        var conParams = {}
        var conId = ''
        if (userId !== undefined && this.searchData.includes(userId) === false) {
          conParams = { userId: userId }
          conId = userId
        } else if (userId === undefined) {
          if (this.$refs.userTree) {
            let NodesArr = this.$refs.userTree.getCheckedNodes()
            if (NodesArr.length === 0) {
              this.$message({ type: 'error', message: '请选择人员!' })
              return
            }
            conParams = { userId: NodesArr[0].id }
            conId = NodesArr[0].id
          } else {
            this.setAlertVisible = false
            return
          }
        }
        saveCall(conParams).then(res => {
          if (res.state === 0) {
            this.setAlertVisible = false
            window.addEventListener('scroll', this.handleScroll, true)
            this._getSelectList('', conId)
            this.lists = []
          }
        })
      } else {
        this.updateAborat()
      }
    },
    updateAborat() {
      let NodesArr = this.$refs.userTree.getCheckedNodes()
      let idArr = []
      console.log(NodesArr)
      for (let item of NodesArr) {
        // 单个成员判断
        if (item.ouId) {
          idArr.push(item.id)
        }
      }
      if (this.groupName === '') {
        this.$message({ type: 'error', message: '请输入广播群组名称!' })
        errorCollection('语音通讯', '添加广播群组', { status: 200, data: { state: -1, msg: '请输入广播群组名称!' } })
      } else if (idArr.length === 0) {
        this.$message({ type: 'error', message: '请选择至少一位群员!' })
        errorCollection('语音通讯', '添加广播群组', { status: 200, data: { state: -1, msg: '请选择至少一位群员!' } })
      } else {
        let params = {
          sessionName: this.groupName,
          userIds: idArr,
        }
        saveBroadcast(params).then(res => {
          if (res.state === 0) {
            this._getSelectList('', this.groupName)
            this.setAlertVisible = false
            window.addEventListener('scroll', this.handleScroll, true)
            this.groupName = ''
            this.lists = []
          }
        })
      }
    },
    cancelUpdate() {
      this.setAlertVisible = false
      window.addEventListener('scroll', this.handleScroll, true)
    },
    //录制语音
    handleBtnClick: function() {
      if (this.searchData.length > 0) {
        // 判断是否有人员/广播才可以点击录音
        let that = this
        rc.start()
          .then(() => {
            that.recording = true
            that.endPlay = true
            console.log('start recording')
            this.minutes = 0
            this.clearTime = setInterval(this.startTimer, 1000)
          })
          .catch(error => {
            this.$message({
              type: 'error',
              message: '获取麦克风失败',
              customClass: 'zZindex',
              duration: 2000,
            })
            errorCollection('语音通讯', '获取麦克风权限', { status: 200, data: { state: -1, msg: '获取麦克风失败!' } })
            console.log('Recording failed.', error)
          })
      } else {
        this.$message({ type: 'error', message: '请先选择人员或者群组!' })
        errorCollection('语音通讯', '录制语音', { status: 200, data: { state: -1, msg: '请先选择人员或者群组!' } })
      }
    },
    startTimer() {
      // 开始录音计时
      this.minutes = this.minutes + 1
      if (22 <= this.minutes) {
        // 录音到22秒后 倒计时提示
        this.stopMinutes--
        this.stopTip = true
        this.stopMinutes = this.stopMinutes
      }
      if (this.minutes >= 30) {
        // 录音到30秒后 录音自动结束
        clearInterval(this.clearTime)
        this.endPlay = false
        this.sendCancel = true
        this.news_img = false
        this.recording = false
        this.stopTip = false
      }
    },
    cancel_mp3: function() {
      //结束语音
      rc.pause()
      clearInterval(this.clearTime)
      if (this.minutes < 1) {
        // 录音时长小于1 提示
        this.$message({
          type: 'error',
          message: '录音时长太短',
          duration: 2000,
        })
        errorCollection('语音通讯', '录制语音', { status: 200, data: { state: -1, msg: '录音时长太短' } })
        this.endPlay = false
        this.sendCancel = false
        this.news_img = true
        this.recording = false
      } else {
        this.endPlay = false
        this.sendCancel = true
        this.news_img = false
        this.recording = false
      }
    },
    cancel: function() {
      // 取消语音
      rc.clear()
      this.sendCancel = false
      this.news_img = true
      let audio = this.$refs.audioUrlRefText
      if (audio.readyState > 0) {
        this.fileTime = parseInt(audio.duration % 60)
      }
    },
    send_voice: function() {
      //发送语音
      let now = new Date().valueOf()
      if (this.lastTime === 0) {
        this.lastTime = now
        var wav = rc.getRecord({
          encodeTo: ENCODE_TYPE.WAV,
          compressible: true,
        })
        var formData = new FormData()
        formData.append('file', wav)
        formData.append('time', this.minutes)
        formData.append('voiceSign', 1)
        formData.append('sessionId', this.currenData.id)
        uploadFile(formData).then(res => {
          if (res.state === 0) {
            rc.clear()
            this.IsScroll = false
          }
          this.sendCancel = false
          this.news_img = true
          this.lastTime = 0
        })
      } else {
        console.log('重复点击')
      }
    },
  },
  mounted() {
    var that = this
    // 判断当前是通话还是广播
    if (that.title === '语音消息') {
      that.recordType = 0
    } else if (that.title === '广播') {
      that.recordType = 1
    }
    that._getSelectList('', '')
    // 监听滚动条执行handleScroll()
    that.$nextTick(() => {
      that.toScrollBottom()
      window.addEventListener('scroll', that.handleScroll, true)
    })
  },
  watch: {
    // 监听已有人员查询
    userName(val) {
      this._getSelectList(val, '')
    },
    addUsername(val) {
      // 监听新增用户查询
      this.$refs.userTree.filter(val)
    },
    sendVoice(val) {
      // 监听ws接受的语音进行更新
      var that = this
      that.wsData = val
      that._getSelectList('', '', val.sessionId)
      setTimeout(() => {
        that.$nextTick(() => {
          that.$refs.chatContent.scrollTop = that.$refs.chatContent.scrollHeight
        })
      }, 500)
    },
    sosVoice(val) {
      // 监听ws接受的sos求助语音进行更新
      this.lists = []
      this.pageNum = 1
      this.title = '语音消息'
      this.recordType = 0
      this.updateUser(val.userId)
      this._getSelectList('', '', val)
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight
        })
      }, 500)
    },
    getTheme(val) {
      this.theme = val
    },
    voiceShow(val) {
      if (val === false) {
        this.show = false
      }
    },
  },
  computed: {
    // 语音长度随语音秒数变化
    widthPercent(item) {
      return function(item) {
        let itemNew = Number(item)
        if (itemNew <= 2) {
          return { width: '70px' }
        } else if (itemNew >= 30) {
          return { width: '180px' }
        } else {
          return { width: (itemNew / 30) * 100 + 60 + 'px' }
        }
      }
    },
    sendVoice() {
      return store.state.accetpVoice
    },
    // 主题切换标识监听
    getTheme() {
      return store.state.theme
    },
    sosVoice() {
      return store.state.sosVoice
    },
    voiceShow() {
      return store.state.voiceShow
    },
  },
  beforeDestroy() {
    // 销毁监听的滚动条
    window.removeEventListener('scroll', this.handleScroll, true)
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
// 渐变过渡
.fade-enter, .fade-leave-active
  opacity 0
.fade-enter-active, .fade-leave-active
  transition opacity 0.35s
// 全局弹窗
.mask
  position fixed
  top 0
  z-index 10
  width 100%
  height 100%
.pop
  width 800px
  min-width 500px;/*no*/
  border-radius 8px
  position fixed
  top 50%
  left 50%
  transform translate(-50%, -50%)
  z-index 2080
.voice
  height 600px
  .conver-title
    display flex
    justify-content space-between
    font-size 20px
    padding 15px
    .title-name
      font-weight 600
    .add
      img
        width 24px
        height 24px
        cursor pointer
  .search
    text-align center
.serachLine
  height 465px
  overflow auto
  margin-top 15px
  ul
    li
      position relative
      display flex
      align-items center
      padding 15px
      border-bottom 1px solid var(--pop-head-port-bg)
      .head-port
        position relative
        width 40px
        height 40px
        line-height 40px
        margin-right 10px
        border-radius: 8px
        font-size: 20px
        text-align center
        bg-image-full('~@/icon/voice/head_port.png')
        .is-read
          position absolute
          top 0
          right 0
          display block
          width 5px;/*no*/
          height 5px;/*no*/
          border-radius 50%
          background red
      .info-port
        font-size 14px
        .person-name
          font-size 16px
          font-weight bold
        .broad-name
          display flex
          align-items center
          width 150px
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          font-size 16px
          font-weight bold
          .group_icon
            width 20px
            height 20px
            margin-right 10px
      .icon-right
        position absolute
        right 5px
        .last-time
          font-size 12px
          margin-bottom 3px
        .addicon
          display none
          width 20px
    .hoverBg
      &:hover .addicon
        display block
    .curren-hight
      background rgba(#666,0.2)
      .name-light
        color #0E65DD!important
      .name-dark
        color #00DEFF!important
    .no-data
      color #999
#audio
  display none
.log-title
  display flex
  align-items center
  position relative
  height 50px
  border-radius 4px
  padding-left 22px
  span
    line-height 50px
    font-size 20px
  .groupArr
    display inline-block
    width 24px
    height 24px
    margin-right 10px
  .edit_borst
    width 32px
    height 32px
    margin-left 10px
    cursor pointer
  .group-light
    bg-image-full('~@/icon/group.png')
  .group-dark
    bg-image-full('~@/icon/ic_group.png')
  .sys-close-btn
    position absolute
    top 50%
    right 10px
    transform translate(0, -50%)
    display block
    cursor pointer
#log
  height 390px
  margin 10px auto
  .chat
    height 390px
    overflow auto
    padding 0 20px
    .waveform
      margin-top 30px
      .message-row-left
        display flex
        flex-direction row
        align-items center
      .message-row-right
        display flex
        flex-direction row-reverse
        align-items center
      .text-chat
        .nick-time
          text-align right
          margin-right 8px
        .message-text
          background: #1485ee;
          float: right
          font-size: 0.08333333rem;
          font-weight: 400;
          color: #fff;
          padding: 0.046875rem 0.09895833rem 0.05208333rem 0.11458333rem;
          line-height: 0.10416667rem;
          border-radius: 0.02083333rem;
          position: relative;
          margin-right: 8px;
          width: fit-content
      .info-chat
        .nick-name-left
          font-size 14px
          font-weight 400
          display flex
          flex-direction row
          .nick-name
            text-align left
            font-size 12px
          .nick-time
            text-align left
            font-size 12px
            margin-left 5px
        .nick-name-right
          text-align: right
          display: flex
          flex-direction: row-reverse
          font-size 14px
          font-weight 400
          .nick-name
            text-align left
            font-size 12px
          .nick-time
            text-align right
            font-size 12px
            margin-right 5px
      .portrait
        width: 40px
        height: 40px
        margin 0 10px
        border-radius: 8px
        font-size: 20px
        text-align center
        line-height 40px
        bg-image-full('~@/icon/voice/head_port.png')
      .message-alert
        font-size: 14px
        line-height 30px
        font-weight: 400
        color: #FF0040
        text-align center
    .message-nodata
      position absolute
      top 0px
      left 50%
      transform  translate(-50%,0)
      font-size: 12px
  .chat::-webkit-scrollbar
    width: 5px
.talk
  margin 0px auto
  position relative
  height 110px
  .play-icon
    width 118px
    height 118px
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    cursor pointer
  .play-light
    bg-image-full('~@/icon/voice/record_btn.png')
  .play-dark
    bg-image-full('~@/icon/voice/ic_record_btn.png')
  .loader
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
  .endPlay-light
    bg-image-full('~@/icon/voice/record_end.png')
  .endPlay-dark
    bg-image-full('~@/icon/voice/ic_record_end.png')
  .send-cancel
    text-align center
    .send-btn
      width 118px
      height 118px
    .cancel-btn
      width 118px
      height 118px
  .row-btn
    display inline-block
  .stop-talk
    position absolute
    left 50%
    top 88%
    transform translate(-50%, 0)
    font-size 12px
    color #FF0040
.input-box
  margin 10px auto
#setRecord
  .addRecord
    position relative
    line-height 50px
    border-radius 4px
    padding 0 15px
    .back-record
      width 16px
      height 16px
      margin-right 7px
      cursor pointer
    .addRecord-title
      font-size 20px
      font-weight 600
    .record-close
      position absolute
      right 10px
      top 50%
      transform translate(0, -50%)
      display block
      cursor pointer
  .group
    font-size 18px
    font-weight bold
    line-height 40px
    .select-title
      margin-top 10px
  .setTree
    height 400px
    font-size 18px
    text-align center
    line-height 100px
    color red
</style>
